export const APP_NAME_LOGIN: string = "Rehamigo Instanzbroker";
export const APP_NAME_DRAWER: string = "Rehamigo IB";
export const COPYRIGHT_NAME: string = "Rehamigo Instanzbroker";
